import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxModal } from "@axess/limestone"
import { ILessonFilterInitData, LessonFilter, SearchDto } from "./LessonFilter";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { LessonPackageStorage } from "./LessonPackageStorage"

@ModuleName("LessonPackage.LandingPage")
export class LandingPage implements AxInit {
    levelModal: AxModal;
    pTypeModal: AxModal;
    dateModal: AxModal;
    initData: ILessonFilterInitData;

    packageStorage: LessonPackageStorage;

    constructor(private _lessonFilter = new LessonFilter(), private _requestHelper = new RequestHelper()) { }

    AxInit(initData: ILessonFilterInitData): void {
        this.initData = initData;

        //LevelStuff
        this.levelModal = new AxModal();
        this.levelModal.init({
            selector: '.lessonPackage_filter_level-drpdn'
        });

        //personTypeStuff
        this.pTypeModal = new AxModal();
        this.pTypeModal.init({
            selector: '.lessonPackage_filter_pType-drpdn'
        });

        //dateStuff
        this.dateModal = new AxModal();
        this.dateModal.init({
            selector: '.lessonPackage_filter_date-drpdn',
            closeModalBtnSelector: '.lessonPackage_landing_close'
        });

        $('.lessonPackage_landing_level-next').on('click',
            () => {
                this.levelModal.close($('#lessonPackage_landing_level-modal')[0]);
            });

        $('.lessonPackage_landing_pType-next').on('click',
            () => {
                this.levelModal.close($('#lessonPackage_landing_pType-modal')[0]);
            });
            
        $('.lessonPackage_landing_date-next').on('click',
            () => {
                this.levelModal.close($('#lessonPackage_landing_date-modal')[0]);
            });

        this.search.bind(this);
        this._lessonFilter.init(initData);


        this.packageStorage = AxLoad.GetModule<LessonPackageStorage>("LessonPackageStorage");
        const defaultLevel = this.packageStorage.getDefaultLevelStorage();

        if (defaultLevel != null && defaultLevel.length !== 0) {
            this._lessonFilter.setDefaults({
                levels: defaultLevel
            });
            this._lessonFilter.updateLessonLevelText();
        }


        this._lessonFilter.getSearchSubject().subscribe((x) => {
            this.packageStorage.cleanDefaultLevelStorage();
            this.search(x);
        });
    }

    search(currentSearch: SearchDto) {
        this._requestHelper.postToUrl(this.initData.targetUrl, currentSearch);
    }
}
